module.exports = __webpack_public_path__ + "static/scale-model-of-wave-hill-public-gardens-in-yonkers-new-york-60524c8c956e0fc09196d4612cef6415.png";